export default {
	bind(el, binding, vnode) {
		// Validate the duration argument
		const duration = (typeof binding.arg === 'string') ? binding.arg : '0.3s';

		// Validate the initial value
		if(typeof binding.value !== 'boolean') {
			console.warn('Expected a boolean value for v-toggle-open directive');
			return;
		}

		// Initial setup
		el.style.overflow = 'hidden';
		el.style.transition = `max-height ${duration} ease-in-out`;
		el.setAttribute('aria-expanded', false); // Start from a closed state
		el.style.maxHeight = '0'; // Start from a closed state

		// Create a MutationObserver to watch for changes in content
		const observer = new MutationObserver(() => {
			el.style.maxHeight = binding.value ? `${el.scrollHeight}px` : '0';
		});

		// Start observing
		observer.observe(el, { childList: true, subtree: true });

		// Watch for changes to the boolean prop
		const unwatch = vnode.context.$watch(
				() => binding.value,
				(newVal) => {
					if(typeof newVal !== 'boolean') {
						console.warn('Expected a boolean value for v-toggle-open directive');
						return;
					}

					// Update aria-expanded attribute
					el.setAttribute('aria-expanded', newVal);

					// Update max height
					el.style.maxHeight = newVal ? `${el.scrollHeight}px` : '0';
				}
		);

		// Initial state
		vnode.context.$nextTick(() => {
			setTimeout(() => {
				el.style.maxHeight = binding.value ? `${el.scrollHeight}px` : '0';
				el.setAttribute('aria-expanded', binding.value); // Update to the initial state
			}, 500); // Give it a small delay to ensure the closed state is applied first
		});

		// Cleanup
		el._toggleHeightUnwatch = unwatch;
		el._toggleHeightObserver = observer;
	},
	update(el, binding) {
		// This will be called whenever the binding value changes
		if(typeof binding.value !== 'boolean') {
			console.warn('Expected a boolean value for v-toggle-open directive');
			return;
		}

		// Update aria-expanded attribute
		el.setAttribute('aria-expanded', binding.value);

		// Update max height
		el.style.maxHeight = binding.value ? `${el.scrollHeight}px` : '0';
	},
	unbind(el) {
		// Stop watching the property if the directive is unbound
		if(el._toggleHeightUnwatch) {
			el._toggleHeightUnwatch();
		}

		// Disconnect the MutationObserver
		if(el._toggleHeightObserver) {
			el._toggleHeightObserver.disconnect();
		}
	}
};
